import { render, staticRenderFns } from "./Equipamiento.vue?vue&type=template&id=31b94cf4&scoped=true"
import script from "./Equipamiento.vue?vue&type=script&lang=js"
export * from "./Equipamiento.vue?vue&type=script&lang=js"
import style0 from "./Equipamiento.vue?vue&type=style&index=0&id=31b94cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b94cf4",
  null
  
)

export default component.exports